import { LangRes, langType } from "./types";

// const isProd = window.location.hostname === "www.abc.com";

/**
 * 翻译类型
 */
export const langs: langType = {
  zh: { name: "中文(简体)" },
  en: { name: "English" },
  // ar: { name: "اللغة العربية" }, // 阿拉伯文
  // fr: { name: "Français" }, // 法语
  ru: { name: "Pусский язык" }, // 俄罗斯语
  // es: { name: "Español" }, // 西班牙语
  pt: { name: "Português" }, // 葡萄牙语言
};

/**
 * 语言类型下拉选项
 */
export const localOptions = (lang: string): any => {
  /**
   * 显示翻译语言的下拉选项
   * 生产目前显示 en, zh
   */
  // const langShowArr =
  //   langHostEnv.isProd && !window.location.hostname.includes("dev")
  //     ? ["en", "zh"]
  //     : Object.keys(langs);

  return (
    Object.keys(langs)
      // .filter(key => langShowArr.includes(key))
      .map(key => {
        return {
          // value: key,
          key,
          label: langs[key].name,
          disabled: lang === key
        };
      })
  );
};
/**
 * 获取当前语言
 * @returns 返回当前语言字符串: zh_CN
 */
export const getLang = (): LangRes => {
  /** 浏览器语言 */
  let browserLang =
    navigator.language !== undefined ? navigator.language : (navigator as any).browserLanguage;
  browserLang = browserLang.toLowerCase().substr(0, 2); // 截取lang前2位字符即可

  return {
    browserLang, // zh
    language: navigator.language, // allLanguage 的第一个值
    allLanguage: navigator.languages // 浏览器用户选择的所有语言 ['zh-CN', 'zh', 'en']
  };
};

/**
 * 设置语言 cookie，缓存7天
 * @param locale 语言
 * @param maxAge 缓存时间
 */
export const setLocaleCookie = (locale: string, maxAge = 604800): void => {
  if (typeof window !== "undefined") {
    document.cookie = `NEXT_LOCALE=${locale}; SameSite=Strict; max-age=${maxAge}; path=/`;
  }
};
